export enum SceneType {
  car = "car",
  goat = "goat",
}
